import { Formik, Form as FormikForm } from 'formik';

import { ValidationError } from '../../services/ValidationError';

import type React from 'react';
import type {
  FormikFormProps,
  FormikProps,
  FormikValues,
  FormikErrors,
} from 'formik';

type Props<T> = Omit<FormikFormProps, 'children'> & {
  children: React.ReactNode | ((formik: FormikProps<T>) => React.ReactNode);
  initialValues?: FormikProps<T>['initialValues'];
  onSubmit?: (values: FormikProps<T>['values']) => Promise<void>;
};

export function Form<T extends FormikValues>({
  children,
  initialValues = {} as FormikProps<T>['initialValues'],
  onSubmit,
  ...props
}: Props<T>) {
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={async (values, actions) => {
        try {
          await onSubmit?.(values);
        } catch (error) {
          console.error(error);
          if (error instanceof ValidationError) {
            actions.setErrors(error.errors as FormikErrors<T>);
          }
        }
      }}
    >
      {typeof children === 'function' ? (
        (formik) => <FormikForm {...props}>{children(formik)}</FormikForm>
      ) : (
        <FormikForm {...props}>{children}</FormikForm>
      )}
    </Formik>
  );
}
